import { connect } from 'react-redux';

import FreshsalesConfigurationView from './FreshsalesConfigurationView.jsx';
import { authenticateAccount } from 'src/legacy/redux/actions/integrations/freshsales.jsx';
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from "src/legacy/redux/actions/adoption";

const mapStateToProps = (state, ownProps) => {
  return {
    errors: state.legacyRootReducer.settings.integrations.freshsales.changes.error,
    updating: state.legacyRootReducer.settings.integrations.freshsales.changes.saving,
    loading: state.legacyRootReducer.settings.integrations.freshsales.changes.loading,
    user: state.users.me,
    integration: getIntegrationForType(state, 'freshsales'),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateAccount: (request) => {
      return dispatch(authenticateAccount(request))
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName));
    }
  }
}

const FreshsalesConfigurationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(FreshsalesConfigurationView);

export default FreshsalesConfigurationPage;
